import { Fragment, ReactNode } from "react";
interface CopyRowProps {
  title: string | ReactNode;
  children: ReactNode;
}

export default function CopyRow({ title, children }: CopyRowProps) {
  return (
    <Fragment>
      <div className="w-full h-[1.375rem] flex justify-between items-center">
        <span className="grid-cols-1 h-[1.375rem] flex flex-row items-center w-fit min-w-[8.5rem] text-white text-[0.75rem] font-semibold">
          {title}
          {title && ":"}
        </span>
        <div className="grid-cols-1 h-[1.375rem] flex flex-row gap-[0.3rem] w-full">
          {children}
        </div>
      </div>
    </Fragment>
  );
}
